export default __webpack_public_path__ + "media/images/features/saga/title-6af4e49c3589633e355db0d64e866fdf.png";